import React from 'react';
import { formatDate, formatRelative } from '../../../utils/format';

const latestUpdate = (sessions, fallback) => sessions.reduce(
  (latest, s) => (s.updatedAt && (!latest || new Date(s.updatedAt) > new Date(latest)) ? s.updatedAt : latest),
  fallback,
);

/** Session count, contributors, creation date and last activity of an event. */
export default function EventSummaryStats({ event, sessions }) {
  const contributors = new Set(sessions.map((s) => s.userName).filter(Boolean)).size;
  return (
    <div className="event-detail-stats">
      <div><span>Sessions</span><strong>{sessions.length}</strong></div>
      <div><span>Contributors</span><strong>{contributors || '—'}</strong></div>
      <div><span>Created</span><strong>{formatDate(event?.created_at)}</strong></div>
      <div><span>Last activity</span><strong>{formatRelative(latestUpdate(sessions, event?.updated_at))}</strong></div>
    </div>
  );
}
